import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-date-range-container',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './date-range-container.component.html',
  styleUrl: './date-range-container.component.scss'
})
export class DateRangeContainerComponent {
  @Input() resolvedDateRange!: string;
}
